import get from "lodash/get"
import axios from "axios"
import {
  FETCH_DATA_LOCAL_SITE_FULFILLED,
  FETCH_DATA_LOCAL_SITE_FAILED,
} from "constants-lib/actionTypes"
import {
  GET_LOCALSITES_CDN_PENDING,
  GET_LOCALSITES_CDN_FULFILLED,
  GET_LOCALSITES_CDN_FAILED,
} from "constants-lib/localSites"

const fulfilledAC = (data) => ({
  type: FETCH_DATA_LOCAL_SITE_FULFILLED,
  payload: data,
})

const failedAC = (statusCode) => ({
  type: FETCH_DATA_LOCAL_SITE_FAILED,
  payload: statusCode,
})

const pendingCDN = () => ({
  type: GET_LOCALSITES_CDN_PENDING,
})

const fulfilledCDN = (data) => ({
  type: GET_LOCALSITES_CDN_FULFILLED,
  payload: data,
})

const failedCDN = (statusCode) => ({
  type: GET_LOCALSITES_CDN_FAILED,
  payload: statusCode,
})

/**
 * Retrieves data from a Localsites CDN.
 * @function
 * @param {string} data_url - The URL of the data to retrieve from the CDN.
 */
export const getLocalsitesCdn = (data_url) => (dispatch) => {
  dispatch(pendingCDN())

  return axios(data_url)
    .then((response) => {
      dispatch(fulfilledCDN(response.data))
    })
    .catch((e) => {
      dispatch(failedCDN(e.response.status))
    })
}

/**
 * Fetches data from a local site.
 * @function
 * @param {string} [url] - The URL to fetch data from. If not provided, the URL is retrieved from the redux state.
 */
export const fetchDataLocalsite = (url) => (dispatch, getState) => {
  const state = getState()
  const getOptions = url || get(state, `localsitesCdn.data_url`, ``)

  return axios
    .get(getOptions)
    .then((response) => {
      dispatch(fulfilledAC(response.data))
    })
    .catch((e) => {
      dispatch(failedAC(e.response?.status))
    })
}
